import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { GenericService } from "./generic.service";
import { environment } from "src/environments/environment";
import { ServerResponse } from "../models/ServerResponse";
import { DialogRef, ISAPI, ISDialogService, ISPagination } from "is-lib";
import { IContract } from "../models/ContractResponse";
import { UsersService } from "./users.service";
import { ca, tr } from "intl-tel-input/i18n";
import { HttpParams } from "@angular/common/http";
import { ContractAccessRequest } from "../models/ContractAccessRequest";

@Injectable({
    providedIn: `root`
})

export class ContractsAccessRequestsService{

    constructor(private _httpService: GenericService) { }

    confirmAccess (country: string, token: string): Observable<ServerResponse<any>> {
        return this._httpService.put(environment.apiUrl + 'ContractAccesses/' + country + '/ContractAccessRequest/' + token + '/ConfirmAccess', undefined, undefined, true)
    }

}